export const projectsList = {
  label: 'Nom del Projecte',
  price: 'Preu del Projecte: 3. 400 €',
  execution: 'Execució del Pressupost: 324. 166 €',
};
